var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client/react';
import { useMount } from 'react-use';
import { useActiveDocument } from 'shared/domains/documents';
import { PdfUrlDocument } from './PdfUrl.gql';
export function usePdfUrl() {
    var _a;
    const { id: documentId } = useActiveDocument();
    const [mutate, { data, loading, error }] = useMutation(PdfUrlDocument);
    const url = (_a = data === null || data === void 0 ? void 0 : data.downloadFileSystemDocument.signed) === null || _a === void 0 ? void 0 : _a.url;
    const getPdf = () => __awaiter(this, void 0, void 0, function* () {
        try {
            return yield mutate({ variables: { documentId } });
        }
        catch (_b) {
            return null;
        }
    });
    useMount(getPdf);
    return { url, loading, error: Boolean(error) };
}
